import { api } from './api';
import {
  GoodsReceipt,
  CreateGoodsReceiptData,
  GoodsReceiptFilters,
  GoodsReceiptsResponse
} from '../types/goodsReceipt';

export const goodsReceiptService = {
  async getGoodsReceipts(filters: GoodsReceiptFilters = {}): Promise<GoodsReceiptsResponse> {
    const params = new URLSearchParams();

    if (filters.search) params.append('search', filters.search);
    if (filters.status) params.append('status', filters.status);
    if (filters.purchaseOrderId) params.append('purchaseOrderId', filters.purchaseOrderId);
    if (filters.warehouseId) params.append('warehouseId', filters.warehouseId);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));

    const response = await api.get(`/goods-receipts?${params.toString()}`);
    return response.data;
  },

  async getGoodsReceipt(id: string): Promise<GoodsReceipt> {
    const response = await api.get(`/goods-receipts/${id}`);
    return response.data;
  },

  async createGoodsReceipt(data: CreateGoodsReceiptData): Promise<GoodsReceipt> {
    const response = await api.post('/goods-receipts', data);
    return response.data;
  },

  async postGoodsReceipt(id: string): Promise<GoodsReceipt> {
    const response = await api.patch(`/goods-receipts/${id}/post`);
    return response.data;
  },

  async deleteGoodsReceipt(id: string): Promise<void> {
    const response = await api.delete(`/goods-receipts/${id}`);
    return response.data;
  },

  async cancelGoodsReceipt(id: string): Promise<GoodsReceipt> {
    const response = await api.patch(`/goods-receipts/${id}/cancel`);
    return response.data;
  }
};
